import { memo } from 'react';
import { Col, Row } from 'reactstrap';
import {
  Column,
  AutoSizer,
  InfiniteLoader,
  Table as VirtualizedTable,
  IndexRange,
} from 'react-virtualized';
import NoData from 'common/NoData';
import RowRenderer from './components/RowRenderer';

type RecordListProps = {
  data: any[];
  handleRowClick: (row: any) => void;
  loadMore: (params: IndexRange) => Promise<any>;
};

const RecordList = memo(
  ({ data, handleRowClick, loadMore }: RecordListProps) => {
    console.log('RecordList redering on search update');

    return (
      <Row className="mt-4">
        <Col style={{height:"calc(100vh - 130px)"}} >
          {data && data.length > 0 ? (
            <>
              {/* <ExportExcel allData={formatData} config={partnerExcelConfig} /> */}
              <InfiniteLoader
                isRowLoaded={({ index }) => !!data?.[index]}
                // loadMoreRows={loadMore}
                loadMoreRows={loadMore}
                rowCount={data?.length}
              >
                {({ onRowsRendered, registerChild }) => (
                  <AutoSizer>
                    {({ width, height }) => (
                      <VirtualizedTable
                        ref={registerChild}
                        onRowsRendered={onRowsRendered}
                        rowClassName="table-row"
                        headerHeight={32}
                        width={width}
                        height={height}
                        rowHeight={45}
                        rowCount={data.length}
                        rowGetter={({ index }) => data?.[index]}
                        onRowClick={handleRowClick}
                        rowRenderer={(props) => <RowRenderer {...props} />}
                      >
                        <Column
                          id="Name"
                          label="Name"
                          dataKey="name"
                          width={width * 0.3}
                        />
                        <Column
                          id="gender"
                          label="Gender"
                          dataKey="gender"
                          width={width * 0.3}
                        />
                        <Column
                          id="role"
                          label="Role"
                          dataKey="role"
                          width={width * 0.3}
                        />
                        <Column
                          id="phone"
                          label="Phone"
                          dataKey="phone"
                          width={width * 0.3}
                        />
                        <Column
                          id="address"
                          label="Address"
                          dataKey="address"
                          width={width * 0.3}
                        />
                        <Column
                          id="status"
                          label="Status"
                          dataKey="status"
                          width={width * 0.1}
                        />
                      </VirtualizedTable>
                    )}
                  </AutoSizer>
                )}
              </InfiniteLoader>
            </>
          ) : (
            <NoData customMessage={'No result found. '} />
          )}
        </Col>
      </Row>
    );
  },
);

export default RecordList;
